/* Cars4Part product page: live price + savings, Buy 1/2/3 quantity options, description "Read more", related products. */

(() => {
  if (window.customElements.get('c4p-qty-breaks')) return;

  const productForm = (productId) =>
    document.querySelector(`form[is="product-form"][id^="product-form-${productId}-"]`) ||
    document.querySelector(`form[id^="product-form-${productId}-"]`);

  const pageData = (productId) => {
    const el = document.querySelector(`c4p-pdp-price[data-product-id="${productId}"] [data-c4p-variants]`);
    if (!el) return { moneyFormat: '', variants: [] };
    try { return JSON.parse(el.textContent); } catch (error) { return { moneyFormat: '', variants: [] }; }
  };

  const formatMoney = (cents, format) => {
    const fmt = window.themeVariables?.settings?.moneyFormat || format || '${{amount}}';
    const match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    const value = Math.round(Number(cents) || 0);
    const number = (decimals, thousands, decimal) => {
      const fixed = (value / 100).toFixed(decimals);
      const [whole, frac] = fixed.split('.');
      const withSep = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return frac ? `${withSep}${decimal}${frac}` : withSep;
    };
    let amount;
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': amount = number(0, ',', '.'); break;
      case 'amount_with_comma_separator': amount = number(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': amount = number(0, '.', ','); break;
      default: amount = number(2, ',', '.');
    }
    return match ? fmt.replace(match[0], amount) : `$${amount}`;
  };

  // Variant from the theme's variant:change event (cents) or from our own JSON
  const variantFrom = (event, data) => {
    const v = event?.detail?.variant;
    if (v) return { id: v.id, price: v.price, compare: v.compare_at_price || 0, available: v.available };
    return null;
  };

  const currentVariant = (productId, data) => {
    const form = productForm(productId);
    const id = Number(form?.querySelector('[name="id"]')?.value);
    return data.variants.find((v) => v.id === id) || data.variants[0];
  };

  /* ---------- Price with savings ---------- */
  class C4pPdpPrice extends HTMLElement {
    connectedCallback() {
      this.productId = this.dataset.productId;
      this.data = pageData(this.productId);
      this.abort = new AbortController();
      const bind = () => {
        const form = productForm(this.productId);
        if (!form) return;
        form.addEventListener('variant:change', (event) => {
          const variant = variantFrom(event, this.data) || currentVariant(this.productId, this.data);
          if (variant) this.render(variant);
        }, { signal: this.abort.signal });
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, { once: true });
      else bind();
    }

    disconnectedCallback() { this.abort?.abort(); }

    render(variant) {
      const sale = variant.compare > variant.price;
      const saving = sale ? variant.compare - variant.price : 0;
      const q = (sel) => this.querySelector(sel);
      q('[data-c4p-price]').textContent = formatMoney(variant.price, this.data.moneyFormat);
      q('[data-c4p-price]').classList.toggle('is-sale', sale);
      q('[data-c4p-compare]').textContent = formatMoney(variant.compare, this.data.moneyFormat);
      q('[data-c4p-compare]').hidden = !sale;
      q('[data-c4p-off]').textContent = `${sale ? Math.round((saving * 100) / variant.compare) : 0}% OFF`;
      q('[data-c4p-off]').hidden = !sale;
      q('[data-c4p-save]').textContent = formatMoney(saving, this.data.moneyFormat);
      q('[data-c4p-save-row]').hidden = !sale;
    }
  }

  /* ---------- Buy 1 / Buy 2 / Buy 3 ---------- */
  class C4pQtyBreaks extends HTMLElement {
    connectedCallback() {
      this.productId = this.dataset.productId;
      this.data = pageData(this.productId);
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.input = this.querySelector('[data-c4p-qty]');

      this.querySelectorAll('input[type="radio"]').forEach((radio) => {
        radio.addEventListener('change', () => this.select(radio), { signal });
      });

      const bind = () => {
        const form = productForm(this.productId);
        if (!form) return;
        // form.id would return the form's "id" input, so read the attribute
        const formId = form.getAttribute('id');
        if (formId) this.input.setAttribute('form', formId);
        form.addEventListener('variant:change', (event) => {
          const variant = variantFrom(event, this.data) || currentVariant(this.productId, this.data);
          if (variant) this.render(variant);
        }, { signal });
        // Quantity goes back to the chosen option after a successful add
        form.addEventListener('variant:add', () => this.sync(), { signal });
        this.sync();
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, { once: true });
      else bind();
    }

    disconnectedCallback() { this.abort?.abort(); }

    sync() {
      const checked = this.querySelector('input[type="radio"]:checked');
      if (checked) this.select(checked);
    }

    select(radio) {
      this.input.value = radio.value;
      this.querySelectorAll('.c4p-breaks__option').forEach((option) => {
        option.classList.toggle('is-selected', option.contains(radio));
      });
    }

    render(variant) {
      const reference = variant.compare > variant.price ? variant.compare : variant.price;
      this.querySelectorAll('input[type="radio"]').forEach((radio) => {
        const qty = Number(radio.value);
        const pct = Number(radio.dataset.pct) || 0;
        const total = Math.round((variant.price * qty * (100 - pct)) / 100);
        const was = reference * qty;
        const option = radio.closest('.c4p-breaks__option');
        const totalEl = option.querySelector('[data-c4p-total]');
        const wasEl = option.querySelector('[data-c4p-was]');
        const unitEl = option.querySelector('[data-c4p-unit]');
        totalEl.textContent = formatMoney(total, this.data.moneyFormat);
        wasEl.textContent = formatMoney(was, this.data.moneyFormat);
        wasEl.hidden = was <= total;
        if (unitEl) unitEl.textContent = formatMoney(Math.floor(total / qty), this.data.moneyFormat);
      });
      this.hidden = variant.available === false;
    }
  }

  /* ---------- Description "Read more" ---------- */
  class C4pReadMore extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('[data-c4p-desc]');
      this.button = this.querySelector('[data-c4p-more]');
      this.label = this.querySelector('[data-c4p-more-label]');
      if (!this.content || !this.button) return;

      const check = () => {
        const limit = parseFloat(getComputedStyle(this).getPropertyValue('--c4p-desc-max')) || 320;
        const tall = this.content.scrollHeight > limit + 60;
        this.button.hidden = !tall;
        this.classList.toggle('is-clamped', tall && !this.classList.contains('is-open'));
      };

      this.button.addEventListener('click', () => {
        const open = !this.classList.contains('is-open');
        this.classList.toggle('is-open', open);
        this.classList.toggle('is-clamped', !open);
        this.label.textContent = open ? 'Show less' : 'Read more';
        this.button.setAttribute('aria-expanded', String(open));
        if (!open) this.closest('details')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      // Images inside the description change its height once loaded
      check();
      window.addEventListener('load', check, { once: true });
      this.closest('details')?.addEventListener('toggle', check);
    }
  }

  /* ---------- Related products (product recommendations) ---------- */
  class C4pRelated extends HTMLElement {
    connectedCallback() {
      if (this.loaded || !this.dataset.url) return;
      const load = () => {
        if (this.loaded) return;
        this.loaded = true;
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((html) => {
            const fragment = document.createRange().createContextualFragment(html);
            const fresh = fragment.querySelector('c4p-related-products');
            if (fresh && fresh.querySelector('.c4p-card')) {
              this.replaceWith(fresh);
              window.c4pEta?.(fresh);
            } else {
              this.closest('.shopify-section')?.setAttribute('hidden', '');
            }
          })
          .catch(() => this.closest('.shopify-section')?.setAttribute('hidden', ''));
      };

      if (!('IntersectionObserver' in window)) { load(); return; }
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          this.observer.disconnect();
          load();
        }
      }, { rootMargin: '0px 0px 600px 0px' });
      this.observer.observe(this);
    }

    disconnectedCallback() { this.observer?.disconnect(); }
  }

  /* ---------- Share button (next to the badges) ---------- */
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-c4p-share]');
    if (!button) return;
    const url = button.dataset.url || window.location.href;
    const title = button.dataset.title || document.title;
    if (navigator.share) {
      navigator.share({ title, url }).catch(() => {});
      return;
    }
    navigator.clipboard?.writeText(url).then(() => {
      const label = button.querySelector('[data-c4p-share-label]');
      button.classList.add('is-copied');
      if (label) label.textContent = 'Link copied';
      setTimeout(() => {
        button.classList.remove('is-copied');
        if (label) label.textContent = 'Share';
      }, 2000);
    });
  });

  /* ---------- Cart icon on the Add to cart button ---------- */
  const cartIcon = '<svg class="c4p-atc-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 4h2l2.4 11.2a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.5L21 8H6.2"/><circle cx="10" cy="20.5" r="1.3"/><circle cx="17.5" cy="20.5" r="1.3"/></svg>';

  const decorate = (button) => {
    if (!button.querySelector('.c4p-atc-icon')) button.insertAdjacentHTML('afterbegin', cartIcon);
  };

  const decorateAll = () => {
    document.querySelectorAll('.product-info buy-buttons button[type="submit"]').forEach((button) => {
      decorate(button);
      if (button.dataset.c4pWatched) return;
      button.dataset.c4pWatched = 'true';
      // The theme rewrites the label when the variant changes, so put the icon back
      new MutationObserver(() => decorate(button)).observe(button, { childList: true });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', decorateAll, { once: true });
  else decorateAll();

  customElements.define('c4p-pdp-price', C4pPdpPrice);
  customElements.define('c4p-qty-breaks', C4pQtyBreaks);
  customElements.define('c4p-read-more', C4pReadMore);
  customElements.define('c4p-related-products', C4pRelated);
})();
